import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { Visit, SearchVisitor, SupplementaryEquipmentResponse, InhouseContact } from '../../tmc-visit.model';

@Injectable({
  providedIn: 'root'
})
export class PersonalVisitService {

  constructor(private appServerAPI: AppServerAPI) { }

  public loadPastVisits(identity: Identity): Observable<Visit> {
    return this.appServerAPI.execute<Visit>('/client/control/personalvisit/pastVisits', identity);
  }

  public savePersonalVisit(personalVisit: Visit): Observable<any> {
    return this.appServerAPI.execute<any>('/client/control/personalvisit/save', personalVisit);
  }

  public search(searchVisitor: SearchVisitor): Observable<any> {
    return this.appServerAPI.execute<any>('/client/control/personalvisit/search', searchVisitor);
  }

  public getAvailableSupplementaryEquipments(identity: any): Observable<SupplementaryEquipmentResponse> {
    return this.appServerAPI.execute<SupplementaryEquipmentResponse>('/client/control/personalvisit/supplementaryequipment',
      identity);
  }

  public loadContactDataForloggedInUser(): Observable<InhouseContact> {
    return this.appServerAPI.execute<any>('/client/control/personalvisit/get-inhousecontact-currentuser', {});
  }

}
